import { loadStripe } from "@stripe/stripe-js";
import { CardElement } from "@stripe/react-stripe-js";

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

// OXXO sólo acepta pagos entre 10 y 10,000 MXN
export const OXXO_MAXIMO = 10000;

// Convierte la tarjeta capturada en Stripe Elements en un PaymentMethod (pm_...) para el backend
export async function crearMetodoPago(stripe, elements, nombre) {
	if (!stripe || !elements) throw "Cargando procesador de pagos, intenta de nuevo";
	if (!nombre?.trim()) throw "Por favor llena todos los datos de la tarjeta.";
	const { paymentMethod, error } = await stripe.createPaymentMethod({
		type: "card",
		card: elements.getElement(CardElement),
		billing_details: { name: nombre.trim() },
	});
	if (error) throw error.message;
	return paymentMethod.id;
}

// Si el banco pide 3D Secure, Stripe muestra su propio modal de autenticación
export async function completarAutenticacion(stripe, pago) {
	if (!pago?.requires_action) return;
	const { error } = await stripe.handleNextAction({ clientSecret: pago.client_secret });
	if (error) throw error.message;
}
